import { API } from 'src/utils/interceptor'
import { CUSTOM_ROLES_PAID_PLAN_MESSAGE } from 'src/utils/venueRoleCapabilities'

export const getVenueCustomRolesApiError = error =>
  error?.response?.data?.message ||
  error?.message ||
  'Could not save this custom role.'

export const isCustomRolesPaidPlanError = error =>
  getVenueCustomRolesApiError(error) === CUSTOM_ROLES_PAID_PLAN_MESSAGE

export const listVenueCustomRoles = async venueId => {
  const response = await API.get('api2', `venue/${venueId}/custom-roles`)
  return response?.data
}

export const createVenueCustomRole = async (venueId, payload) => {
  const response = await API.post('api2', `venue/${venueId}/custom-roles`, {
    body: payload,
  })
  return response?.data
}

export const updateVenueCustomRole = async (venueId, roleId, payload) => {
  const response = await API.patch(
    'api2',
    `venue/${venueId}/custom-roles/${roleId}`,
    { body: payload },
  )
  return response?.data
}

export const deleteVenueCustomRole = async (venueId, roleId) => {
  const response = await API.del(
    'api2',
    `venue/${venueId}/custom-roles/${roleId}`,
  )
  return response?.data
}
